module.exports = __webpack_public_path__ + "img/bg.7e687a55.png";